import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
})
theme.spacing(2)

class App extends React.Component {

  render() {
    return pug`
      ThemeProvider(theme=theme)
        Grid(container spacing=2 justify="center" alignItems="center")
          Grid(item xs=12 sm=6 md=3)
            Card
              CardContent
                Typography(variant="h5")
                  Link(href="https://hogehoge-banana.xyz/playground/faceapijs/", target="_blank") Faceapi.js

                Typography(body)
                  | ブラウザ上で動く
                  Link(href="https://github.com/justadudewhohacks/face-api.js/", target="_blank", rel="noopener") 顔認識API
                  | のサンプル実装

          Grid(item xs=12 sm=6 md=3)
            Card
              CardContent
                Typography(variant="h5")
                  Link(href="https://hogehoge-banana.xyz/playground/sls-rtc/", target="_blank") Serverless WebRTC

                Typography(body)
                  Link(href="https://qiita.com/hogehoge-banana/items/2a3c15b8f68de951bfe3", target="_blank", rel="noopener") 過去にQiitaに書いたWebRTCの記事
                  | のサンプルをサーバーレス化してみました
    `;
  }
}

// ========================================

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
